import { Routes } from '@angular/router';
import { PUBLIC_ROUTES } from './public/public.routes';

// Root application routes: reuse the existing PUBLIC_ROUTES and add a wildcard 404
export const APP_ROUTES: Routes = [
  ...PUBLIC_ROUTES,
  { path: '**', loadComponent: () => import('./public/not-found/not-found.component').then(m => m.NotFoundComponent) }
];
